<template>
	<div class="h-100">
		<div class="wrapper">
	  		<header id="header">
	  			<div class="container d-flex align-items-center">
	  				<a href="https://httpsredirect.com" class="logo mr-auto"><img src="https://httpsredirect.com/images/logo.png" alt="" class="img-fluid"></a>
	      			<nav class="nav-menu d-none d-lg-block">
	        			<ul>
							<li><router-link :to="{ name: 'home' }">Home</router-link></li>
							<li><a href="https://httpsredirect.com/#features">Features</a></li>
							<li><a href="https://httpsredirect.com/#pricing">Pricing</a></li>
							<li><a href="https://httpsredirect.com/#faq">FAQ</a></li>
							<li><a href="https://httpsredirect.com/#contact">Contact</a></li>
						</ul>
					</nav>
					<router-link :to="{ name: 'register' }" class="get-started-btn d-none d-lg-block">Get Started</router-link>
					<button @click="showMobileMenu = true" class="mobile-menu-btn btn-plain" type="button"><i class="fa fa-bars"></i></button>
				</div>
				<div class="site-mobile-menu site-navbar-target" :class="{ 'show': showMobileMenu }">
					<div class="site-mobile-menu-header">
						<div class="site-mobile-menu-close mt-3">
							<button @click="showMobileMenu = false" class="text-primary btn-plain"><span class="fa fa-times"></span></button>
						</div>
					</div>
					<div class="site-mobile-menu-body">
						<ul class="site-nav-wrap">
							<li><router-link @click.native="showMobileMenu = false" :to="{ name: 'home' }">Home</router-link></li>
							<li><a @click="showMobileMenu = false" href="https://httpsredirect.com/#features">Features</a></li>
							<li><a @click="showMobileMenu = false" href="https://httpsredirect.com/#pricing">Pricing</a></li>
							<li><a @click="showMobileMenu = false" href="https://httpsredirect.com/#faq">FAQ</a></li>
							<li><a @click="showMobileMenu = false" href="https://httpsredirect.com/#contact">Contact</a></li>
						</ul>
						<router-link :to="{ name: 'register' }" class="get-started-btn ml-3 mt-3">Get Started</router-link>
					</div>
	  			</div>
	  		</header>
  			<router-view></router-view>
  			<div class="wrapper-push"></div>
  		</div>
  		<notifications position="bottom right"/>
  		<footer id="footer">
        	<div class="container footer-bottom clearfix">
        		<div class="copyright">&copy; Copyright <a style="color: initial;" target="_blank" rel="noopener" href="https://tctechss.com"><span>TC Tech Support & Solutions, LLC</span></a> d.b.a. <b>HTTPSredirect</b>. All Rights Reserved</div>
        		<div class="credits">
        			<router-link :to="{ name: 'terms' }" class="text-dark mr-3">Terms and Conditions</router-link>
        			<router-link :to="{ name: 'privacy' }" class="text-dark">Privacy Policy</router-link>
        		</div>
       		</div>
  		</footer>
	</div>
</template>

<script>
	export default {
		name: 'HomeLayout',
		data() {
			return {
				showMobileMenu: false,
			}
		},
	};
</script>